import { Column } from 'react-table';

import { Environment } from '@/core/environments/types';
import { DefaultFilter } from '@/core/components/datatables/components/Filter';

export const group: Column<Environment> = {
  Header: 'Группа',
  accessor: (row) => row.GroupName || '-',
  id: 'groupName',
  Filter: DefaultFilter,
  canHide: true,
};
